import type { SubCheckoutContext } from './billingEntitlement';

/**
 * #1360 — Date a mid-trial converter's card is first charged, formatted for the viewer's locale.
 * Reads subscription-status `trial_ends_at` (user_profiles.trial_ends_at); #1362 sets the Stripe
 * session's trial_end to the same value so the two dates agree.
 * Null when the trial has ended, was never started, or the tier is not `trial`.
 */
export function trialChargeDateLabel(
  ctx: SubCheckoutContext | null | undefined,
  nowMs = Date.now(),
  locale?: string | string[],
): string | null {
  if (!ctx || ctx.subscription_tier !== 'trial' || !ctx.trial_ends_at) return null;
  const end = new Date(ctx.trial_ends_at);
  const endMs = end.getTime();
  if (Number.isNaN(endMs) || endMs <= nowMs) return null;
  return end.toLocaleDateString(locale, { month: 'short', day: 'numeric' });
}
